import React from 'react';
import i18n from '../../../../i18n';

function Language(props) {
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang)
    }

    return (
        <div className="desktop:w-1/2 text-footer-text text-sm flex flex-row gap-4 order-4 desktop:order-3">
            <p
                className="footer-link"
                onClick={()=>handleLanguageChange('kz')}
            >
                Қазақша
            </p>

            <p
                className="footer-link"
                onClick={()=>handleLanguageChange('ru')}
            >
                Русский
            </p>

            <p
                className="footer-link"
                onClick={()=>handleLanguageChange('en')}
            >
                English
            </p>
        </div>
    );
}

export default Language;
